import {AttrsSchema, Component, ConfigOptions} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {IronContextRegistry} from 'common/report/context-registry';
import {Section} from 'common/components/items-menu/types';

import {template} from './template';
import css from './index.inline.styl';
import {CopyBoardModalAttrs, CopyBoardModalState, MappingType} from './types';

export class CopyBoardModal extends Component<CopyBoardModalState, CopyBoardModalAttrs, any, any, IronContextRegistry> {
  static get attrsSchema(): AttrsSchema<CopyBoardModalAttrs> {
    return {
      ...super.attrsSchema,
      'board-events-info': {type: `json`},
    };
  }

  get config(): ConfigOptions<CopyBoardModalState, any, IronContextRegistry> {
    return {
      template,
      css,
      useShadowDom: true,
      defaultState: {
        boardEventsMapping: null,
      },
      contexts: [`currentProject` as const],
      helpers: {
        getDropdownSections: (mappingType: MappingType): Section[] => {
          // TODO: actually retrieve all events within a board
          return [
            {items: Object.keys(this.state.boardEventsMapping[mappingType]).map((value: string) => ({label: value}))},
          ];
        },
        handleDropdownSelected: (mappingType, key, ev) => {
          const boardEventsMapping = this.state.boardEventsMapping;
          this.update({
            boardEventsMapping: {
              ...boardEventsMapping,
              [mappingType]: {...boardEventsMapping[mappingType], [key]: ev.detail.value},
            },
          });
        },
      },
    };
  }

  connectedCallback(): void {
    super.connectedCallback();
  }

  attributeChangedCallback(attr, oldVal, newVal) {
    super.attributeChangedCallback(attr, oldVal, newVal);
    if (attr === `board-events-info`) {
      const boardsEventsInfo = this.attr(`board-events-info`);

      // default to existing event/property name
      const eventsMapping = Object.fromEntries(boardsEventsInfo.events.map((key) => [key, key]));
      const propertiesMapping = Object.fromEntries(boardsEventsInfo.properties.map((key) => [key, key]));
      this.update({boardEventsMapping: {events: eventsMapping, properties: propertiesMapping}});
    }
  }
}

export const CopyBoardModalEl = defineAndMakeJsxFactory(`copy-board-modal`, CopyBoardModal);
